import{a as m,b as i}from"./chunk-YWXGNONA.js";import{f as o,w as e}from"./chunk-SNQHK5AK.js";import{e as r,m as a}from"./chunk-HBP5N4FR.js";var u,l=r(()=>{a();e();i();u=t=>({egldValueData:{value:t,formattedValue:m({input:t}),decimals:o}})});export{u as a,l as b};
//# sourceMappingURL=chunk-MQPQDNN7.js.map
